// Imports
import { useCallback } from 'react';
import { Stripe } from '@stripe/stripe-js';
import useStoredPaymentMethodSubmission from './use-stored-payment-method-submission';


// Define the accepted options
interface Options {
	stripeAccountID: string;
	selectedCardID: string;
	onSuccess: () => void;
}


// A hook that handles confirming a saved card payment using Stripe
const useSavedCardPayment = ({ stripeAccountID, selectedCardID, onSuccess }: Options) => {
	// Build the Stripe confirmation callback for saved cards
	const confirm = useCallback(
		(stripe: Stripe, clientSecret: string) => {
			return stripe.confirmCardPayment(clientSecret, {
				payment_method: selectedCardID,
			});
		},
		[selectedCardID]
	);
	
	
	// Delegate to the shared submission hook
	return useStoredPaymentMethodSubmission({
		stripeAccountID,
		confirm,
		onSuccess,
	});
};

export default useSavedCardPayment;
